<div class="location-picker" [ngClass]="{ variant: variant }">
	<div class="label-default" *ngIf="isOutLabel">
		{{ 'locationPicker.label' | translate }}
	</div>
	<mat-form-field
		[appearance]="appearance"
		class="location-picker__field"
		[class]="isOutLabel && 'location-picker__field--out'"
	>
		<mat-label *ngIf="!isOutLabel">
			{{ 'locationPicker.label' | translate }}
		</mat-label>
		<div class="location-picker__field__label">
			<span class="location-picker__field__label__icon">
				<i class="fa-regular fa-map-location"></i>
			</span>

			<input
				matInput
				[formControl]="searchControl"
				[matAutocomplete]="locationAuto"
				[placeholder]="placeholderKey | translate"
				autocomplete="off"
			/>

			<button
				*ngIf="hasSelection"
				type="button"
				class="location-picker__field__label__close"
				[attr.aria-label]="'locationPicker.clearAriaLabel' | translate"
				(click)="onClear()"
			>
				<i class="fa-regular fa-close"></i>
			</button>
		</div>

		<mat-autocomplete #locationAuto [displayWith]="displayFn" (optionSelected)="onPlaceSelected($event.option.value)">
			<mat-option *ngIf="isLoading" disabled class="location-picker__option--loading">
				{{ 'locationPicker.loading' | translate }}
			</mat-option>
			<ng-container *ngIf="!isLoading">
				<mat-option *ngFor="let prediction of predictions" [value]="prediction">
					{{ prediction.description }}
				</mat-option>
				<mat-option *ngIf="showNoResults" disabled>
					{{ 'locationPicker.noResults' | translate }}
				</mat-option>
			</ng-container>
		</mat-autocomplete>
		<mat-error *ngIf="searchControl.hasError('tooGeneral')">
			{{ 'locationPicker.tooGeneral' | translate }}
		</mat-error>
	</mat-form-field>

	<div *ngIf="showRadiusSlider" class="location-picker__radius">
		<mat-slider
			class="location-picker__slider"
			[value]="radiusControl.value"
			[min]="1"
			[max]="100"
			[step]="1"
			(input)="onRadiusInput($event)"
			(change)="onRadiusChange($event)"
		></mat-slider>
		<span class="location-picker__radius__value paragraph-medium"
			>{{ displayRadius }} {{ 'locationPicker.radiusUnit' | translate }}</span
		>
	</div>

	<!-- Required by Google Places API licence -->
	<div #attributionEl style="display: none"></div>
</div>
